import { generateTestId } from "@client-shared";

export const setRevenueChartTestId = (identifier: string): string => generateTestId("RevenueChart", identifier);

// Specific element testIds
export const setRevenueChartContainerTestId = (): string => setRevenueChartTestId("container");

export const setRevenueChartTitleTestId = (): string => setRevenueChartTestId("title");
